export default __webpack_public_path__ + "static/media/30.ee312ab3.jpg";